module.exports = __webpack_public_path__ + "static/media/7711115A-CCCF-47A7-9BE5-287BCC290B9A-min.9131a11f.jpg";